import { useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { AccountInfoContext } from '../account/account-info';
import { colors } from '../ui-elements/Main/MainTheme';
import { Text as UiText } from '../ui-elements/Main/Text';
import { balanceToUsd } from '@/helpers/app/balance';
import { orgBalanceRemainingSelector } from '@/redux/app/selectors/organization';
import { useNavigationActions } from '@/lib/navigation';
import { useTrialFunnel } from '../trial/trial-funnel';
import { CtaButton, UpgradeButton } from './TrialHeader';

// Replaces the Balance menu for trials: the balance as it shows for paid accounts, plus an Upgrade that turns green once A2P is submitted
export const TrialStatus = () => {
  const { subdomain } = useContext(AccountInfoContext);
  const { upgradeIsNext } = useTrialFunnel();
  const balanceRemaining = useSelector(orgBalanceRemainingSelector);
  const { navigate } = useNavigationActions();
  const Upgrade = upgradeIsNext ? CtaButton : UpgradeButton;

  return (
    <Chip>
      <Balance>
        <UiText fontSize="11px" lineHeight={1.25}>Balance</UiText>
        <UiText fontSize="14px" fontWeight={800} lineHeight={1.25} color={colors.balanceGreen}>
          {balanceToUsd(balanceRemaining)}
        </UiText>
      </Balance>
      <Upgrade
        type="button"
        data-emphasis={upgradeIsNext ? 'primary' : 'secondary'}
        onClick={(e) => {
          e.stopPropagation();
          navigate({ path: `${window.location.origin}/accounts/${subdomain}/billing_v2/upgrade`, params: {} });
        }}
      >
        Upgrade
      </Upgrade>
    </Chip>
  );
};

const Chip = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  height: 48px;
  margin-right: 10px;
  padding: 0 5px 0 20px;
  background: ${colors.sand};
  border-radius: 50px;
`;

const Balance = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
`;
